(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name WebinarsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('WebinarsController', WebinarsController);

    WebinarsController.$inject = ["WebinarsService","$timeout","$location",'$anchorScroll','$window'];

    function WebinarsController(WebinarsService,$timeout,$location,$anchorScroll,$window)
    {
    	var vm = this;
        vm.pag = 0;
        vm.maxPages = 0;
        vm.categoria_id = {};
        vm.buscador = "";
        vm.webinars = [];
        vm.loading = false;
        vm.initVar = true;
        vm.buscarFiltros = function(){
            var url_string = window.location.href
            var url = new URL(url_string);
            if($location.search().categoria_id){
                var cat = {};
                var catSplit = $location.search().categoria_id.split(",");
                for(var cont=0; cont<catSplit.length;cont++){
                    cat[catSplit[cont]] = true;
                }
                vm.categoria_id = cat;
            }

            if($location.search().pag){
                vm.pag = parseInt($location.search().pag);
            }
            
            if($location.search().buscador){
                vm.buscador = $location.search().buscador;
            }
            return true;

        }
        vm.getWebinars = function(){

            vm.loading = true;
             if(vm.initVar){
                 var resF = vm.buscarFiltros();
                 vm.initVar = false;
              }
            WebinarsService.getWebinars(vm,function(data){
                vm.loading = false;
                vm.webinars = data.webinars;
                vm.maxPages = data.maxPages;
                if(vm.pag>0){
                    $("html, body").animate({ scrollTop: $('.filters-webinars').offset().top }, 1000);
                }
                
                var queryParams = new URLSearchParams(window.location.search);
                //console.log(vm);
                if(vm.categoria_id){
                    //console.log(vm.categoria_id);
                    var idsCat = [];
                    for(var [key,val] of Object.entries(vm.categoria_id)){
                        if(val){
                            idsCat.push(key);
                        }
                    }
                    //console.log(idsCat);
                    if(idsCat.length>0){
                        queryParams.set("categoria_id", idsCat.join(","));
                    }else{
                        queryParams.delete("categoria_id");

                    }
                }else{
                    queryParams.delete("categoria_id");
                }
                if(vm.pag){
                    queryParams.set("pag", vm.pag);
                }else{
                    queryParams.delete("pag");
                }
                if(vm.buscador){
                    queryParams.set("buscador", vm.buscador);
                }else{
                    queryParams.delete("buscador");
                }
                $location.url( "?"+queryParams.toString());
                 
                //console.log(vm.maxPages );
            },function(){vm.loading = false;});
        };

        vm.next = function(){
        	vm.pag++;
        	vm.getWebinars();
        };

        vm.prev = function(){
        	vm.pag--;
        	vm.getWebinars();
        };


    }


})();